module.exports = __webpack_public_path__ + "static/revtel-logo2-4545186ab8b681a171f4dd479ae818c8.png";